import { Stack, Switch } from '@mui/material';
import Typography from '@mui/material/Typography';
import RadiusFilter from 'components/FilterFields/DistanceFilter';
import PropTypes from 'prop-types';
import useFilterStore from '../../zustandStore/useFilterStore';
import {LISTINGS, RENTALS, SALES} from '../../constants/comparableTypes';

const AdvancedRadiusFilters = (props) => {
    const targetSuburbOnly = useFilterStore(state => state.filters[props.comparableType].targetSuburbOnly);
    const setFiltersForVariations = useFilterStore(state => state.setFiltersForVariations);
    const handleChange = (e) => {
        setFiltersForVariations([SALES, LISTINGS, RENTALS], { targetSuburbOnly: e.target.checked });
    };

    return (<Stack useFlexGap spacing={1.25} direction="column">
        <Stack direction="row">
            <Stack sx={{ flexBasis: '50%' }} direction="column">
                <Stack>
                    <Typography variant="text1" gutterBottom>Distance</Typography>
                </Stack>
                <Stack mb={1}>
                    <Typography variant="subtitle1" gutterBottom>Select an option or manually enter a value</Typography>
                </Stack>
                <Stack sx={{ '& .MuiAutocomplete-root': { width: '100%' } }}>
                    <RadiusFilter comparableType={props.comparableType} label="Select Distance" />
                </Stack>
            </Stack>
        </Stack>
        <Stack useFlexGap spacing={1.25} direction="row">
            <Stack sx={{ flexBasis: '50%' }} direction="column" mb={1}>
                <Typography variant="text1" gutterBottom>Target Suburb Only</Typography>
                <Typography variant="subtitle1" gutterBottom>Shows the closest properties only within the suburb of the Target property</Typography>
            </Stack>
            <Stack justifyContent="center">
                <Switch
                    checked={targetSuburbOnly}
                    onChange={handleChange}
                    color="primary"
                />
            </Stack>
        </Stack>
    </Stack>);
};

AdvancedRadiusFilters.propTypes = {
    comparableType: PropTypes.string.isRequired,
};

export default AdvancedRadiusFilters;